import { AnalyticsService } from './../analytics/analytics.service';
import { RegistryService } from './../registry/registry.service';
import { Intercom } from 'ng-intercom';
import { environment } from './../../environments/environment';
import { ISubscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { AuthService, User } from './../user/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';

import { FormGroup, FormArray, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { t } from '@angular/core/src/render3';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit, OnDestroy {
  public hitchdForm: FormGroup;
  errorMessage: string;
  socialSubmitting = false;
  submitting = false;
  subscription: ISubscription;
  submitted = false;
  emailSet = false;
  user: User;
  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private _validatorService: CustomValidatorsService,
    private _authService: AuthService,
    private _intercom: Intercom,
    private _registryService: RegistryService,
    private _analyticsService: AnalyticsService
  ) {



  }
  blurEmail() {
    this.emailSet = true;
  }
  ngOnInit() {
    this.hitchdForm = this._fb.group({
      email: ['', [Validators.required, this._validatorService.validateEmail]],
      password: ['', [Validators.required,
      this._validatorService.containsUpperCase
        , Validators.minLength(8)]],
    });

    const loader = document.getElementById('reg-loader');
    if (loader) {
      loader.remove();
    }
  }


  ngOnDestroy() {
  }

  signInFacebook() {
    this.socialSubmitting = true;
    this._authService.facebookLogin().then((x: User) => {

      this.subscription = this._authService.user.subscribe(user => {
        //

        this.sendAdwordConversion();
        if (user != null) {

          this.submitting = false;
          this.user = user;


          if (!this._analyticsService.skipEuMarketing){
            this._registryService.sendFbTrackEvent('Sign up');
            this._intercom.boot({ email: user.email, user_id: user.uid, name: null });
          }
          this.setFullStoryId(user.email);

          this._analyticsService.identifySegmentUser(user);
          this._analyticsService.trackGoogleAdsAndPinterestEvent('Signed up', {});

          if (this.user.registryId) {
            //
            this.router.navigate(['/overview']);
          } else {
            this.router.navigate(['/get-started']);
          }

        } else {
          this.socialSubmitting = false;
        }
      });

      //

      this.router.navigate(['/get-started']);

    }).catch((e: Error) => {

      if (e.message === 'auth/account-exists-with-different-credential') {
        this.errorMessage = 'The account already exists, please try logging in.';
      }
      this.submitting = false;

      this.socialSubmitting = false;
    });
  }


  signInGoogle() {
    this.socialSubmitting = true;
    this._authService.googleLogin().then(x => {

      this.subscription = this._authService.user.subscribe(user => {
        //

        if (user != null) {

          this.sendAdwordConversion();
          this.submitting = false;
          this.user = user;

          if (this.user.registryId) {

            if (!this._analyticsService.skipEuMarketing){
            this._registryService.sendFbTrackEvent('Sign up');

            this._intercom.boot({ email: user.email, user_id: user.uid, name: null });
            }


            this._analyticsService.identifySegmentUser(user);
            this._analyticsService.trackGoogleAdsAndPinterestEvent('Signed up', {});

            this.setFullStoryId(user.email);
            //
            this.router.navigate(['/overview']);
          } else {
            this.router.navigate(['/get-started']);
          }
        } else {
          this.socialSubmitting = false;
        }
      });
    }).catch(
      (e: Error) => {

        if (e.message === 'auth/account-exists-with-different-credential') {
          this.errorMessage = 'The email address is already in use';
        }

        this.socialSubmitting = false;
        this.submitting = false;
      });
  }

sendAdwordConversion(){

  const gtag = window['gtag'];

  if (!gtag) {
    return;
  }

  gtag('event', 'conversion', {
    'send_to': 'AW-784025651/YopPCM-4m5ABELOQ7fUC',
    'signup': true
  });
}

setFullStoryId(email){
  const FS = window['FS'];
  if (FS){
  // This is an example script - don't forget to change it!
FS.identify(email, {
  email: email,
  // TODO: Add your own custom user variables here, details at
  // http://help.fullstory.com/develop-js/setuservars
  reviewsWritten_int: 14
});
}
}

  submit() {
    this.submitted = true;
    this.submitting = true;
    if (this.hitchdForm.valid) {
      const email = this.hitchdForm.controls['email'].value;
      const password = this.hitchdForm.controls['password'].value;
      this._authService.signup(email, password).catch(
        (e) => {
          if (e.message === 'auth/account-exists-with-different-credential') {
            this.errorMessage = 'The email address is already in use';
          } else {
            this.errorMessage = e.message;
          }
          this.submitting = false;

        }
      ).then(x => {

        this.subscription = this._authService.user.take(1).subscribe(user => {
          //
          if (user != null) {

            this.sendAdwordConversion();
            this.submitting = false;
            this.user = user;
            if (!this._analyticsService.skipEuMarketing){
            this._registryService.sendFbTrackEvent('Sign up');

            this._intercom.boot({ email: user.email, user_id: user.uid, name: null});
            }



            this._analyticsService.identifySegmentUser(user);
            this._analyticsService.trackGoogleAdsAndPinterestEvent('Signed up', {});
            this.setFullStoryId(user.email);

            

            if (this.user.registryId) {
              //
              this.router.navigate(['/overview']);
            } else {
              this.router.navigate(['/get-started']);
            }
          }
        });

      }
      );
    } else {
      this.submitted = false;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/signup/signup.component.ts